import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { Route, withRouter } from 'react-router-dom';
import reportsActionCreators from '../../store/reports/action-creators/index';
import ReportIndex from './ReportIndex';

class ReportContainer extends Component {
  // ----------------------
  // Lifecycle
  // ----------------------

  componentWillMount() {
    const { scope } = this.props.userContext;
    this.props.loadReportContainer(scope);
  }

  componentWillUnmount() {
    this.props.unmountReportContainer();
  }

  render() {
    return (
      <Fragment>
        <Route component={ReportIndex} exact path="/reports" />
      </Fragment>
    );
  }
}

// ----------------------
// Redux Mappings
// ----------------------

const mapStateToProps = (state) => {
  return { userContext: state.common.userContext };
};

const mapDispatchToProps = (dispatch) => {
  return {
    loadReportContainer: (scope) => {
      return dispatch(reportsActionCreators.loadReportContainer(scope));
    },
    unmountReportContainer: () => {
      return dispatch(reportsActionCreators.unmountReportContainer());
    },
  };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ReportContainer));
